export const TotpStatus = {
  NotAllowed: 'NotAllowed',
  Allowed: 'Allowed',
  Configured: 'Configured',
} as const;
export type TotpStatus = (typeof TotpStatus)[keyof typeof TotpStatus];
